import { type ComponentProps, useCallback, useMemo } from 'react';

import { useGoals } from '@atlassian/global-shortcuts/goals';
import { useTeams } from '@atlassian/global-shortcuts/teams';
import { GlobalSideNavigation } from '@atlassian/global-side-navigation/GlobalSideNavigation';

import { getConfig } from '@townsquare/config';
import { SideNavAppItem as SideNavAppItemID } from '@townsquare/navigation-config/nav4';
import { useOrgContextOrgId } from '@townsquare/org-context';

export const useSideNavAppItemsForNavPlatform = (): ComponentProps<
	typeof GlobalSideNavigation
>['shortcuts'] => {
	const config = getConfig();
	const orgId = useOrgContextOrgId();

	const teamsItem = useTeams(
		useCallback(
			() => (!orgId ? `${config.fullUrl}/people` : `${config.fullUrl}/o/${orgId}/people`),
			[config.fullUrl, orgId],
		),
		{ menuItemId: SideNavAppItemID.TEAMS_APP },
	);

	const goalsItem = useGoals(
		useCallback(
			() => (!orgId ? `${config.fullUrl}/goals` : `${config.fullUrl}/o/${orgId}/goals`),
			[config.fullUrl, orgId],
		),
		{ menuItemId: SideNavAppItemID.GOALS },
	);

	return useMemo(
		() => ({
			[SideNavAppItemID.TEAMS_APP]: teamsItem,
			[SideNavAppItemID.GOALS_APP]: goalsItem,
		}),
		[teamsItem, goalsItem],
	);
};
